















































import { Vue, Component, Prop } from "vue-property-decorator";
import { mapGetters, mapState } from 'vuex'

const ProgressBarProps = Vue.extend({
  computed: {
    ...mapState('global', [
      'cart',
      'checkout',
    ]),
    ...mapGetters('vas', [
      'hasValidAddressAndShipping',
      'hasDelivery',
    ])
  }
})

@Component
export default class ProgressBar extends ProgressBarProps {
  @Prop() readonly merchant!: MerchantStore;

  get progressDisabled () {
    return this.checkout && this.checkout.status === 'PAYMENT_SUCCESS'
  }

  get routeParams () {
    return {
      merchantId: this.merchant.businessId,
      vasId: this.merchant.id
    }
  }
}
